import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";

import { useLazyGetProtectionPolicyQuery } from "../app/api/public/legals";
import { router } from "../app/services/router";
import { Dialog } from "../features/shared/Dialog";
import { Loader } from "../features/shared/Loader";
import { Markdown } from "../features/shared/Markdown";

import { ReactComponent as Icon } from "./LegalNoticePageIcon.svg";

export const ProtectionPolicyPage = () => {
  const hash = router.getTo("protectionPolicy");
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <Dialog
      open={hash === location.hash}
      onOpenChange={(open) => {
        if (!open) {
          navigate({ ...location, hash: "" });
        }
      }}
    >
      <ProtectionPolicyPageContent
        trigger={
          document.querySelector(`[href*="${hash}"]`) as HTMLAnchorElement
        }
      />
    </Dialog>
  );
};

type ProtectionPolicyPageContentProps = { trigger: HTMLAnchorElement };

const ProtectionPolicyPageContent = (
  props: ProtectionPolicyPageContentProps,
) => {
  const { trigger } = props;

  const [getProtectionPolicy, { currentData: text, error, isFetching }] =
    useLazyGetProtectionPolicyQuery();

  const { t } = useTranslation();
  const { meta, title } = t("pages.ProtectionPolicyPage") as unknown as {
    meta: { title: string };
    title: string;
  };

  return (
    <Dialog.Content
      dataLayer={{
        categorie_page: "protection_policy",
        nom_page: "protection_policy",
        virtualpagetitle: "Politique de protection des données",
      }}
      icon={<Icon />}
      meta={meta}
      title={title}
      onCloseAutoFocus={() => trigger.focus()}
      onOpenAutoFocus={() => getProtectionPolicy(undefined, true)}
    >
      {text ? (
        <Markdown>{text}</Markdown>
      ) : (
        <Loader error={error} isFetching={isFetching} />
      )}
    </Dialog.Content>
  );
};
